import { parse } from 'fter'
import { ChangeEvent } from 'react'
import Checkbox from '../../../../../../components/Checkbox'
import { LabelInline } from '../../../../../../components/FormUtilities'
import Product from '../../../../../../models/Product'
import { get } from '../../../../../../utilities/http'
import { storagePage } from '../../../../storage'
import { formCostGeneral } from '../../storageStep3'
import { RCProps } from './types'

const productsCache = new Map<number, Product[]>()

export default function RC(props: RCProps) {
    async function onChange(ev: ChangeEvent<HTMLInputElement>) {
        const checked = ev.target.checked
        const { rcs, productIds } = formCostGeneral.store()

        if (!checked) {
            const rcProducts = await fetchProductsByRC(Number(props.value))
            const rcProductIds = rcProducts.map(p => p.id)
            const newProductIds = productIds.filter(
                id => !rcProductIds.includes(id)
            )

            formCostGeneral.setValue('productIds', newProductIds)
            const rcsFiltered = rcs.filter(rc => rc.value !== props.value)
            formCostGeneral.setValue('rcs', rcsFiltered)
        } else {
            if (!rcs.find(rc => rc.value === props.value)) {
                const rcProducts = await fetchProductsByRC(Number(props.value))
                const rcProductIds = rcProducts.map(p => p.id)

                const newProductIds = [...productIds]
                rcProductIds.forEach(id => {
                    if (!newProductIds.includes(id)) {
                        newProductIds.push(id)
                    }
                })

                formCostGeneral.setValue('productIds', newProductIds)
                formCostGeneral.setValue('rcs', [
                    ...rcs,
                    { value: props.value, label: props.label }
                ])
            }
        }
    }

    return (
        <LabelInline label={props.label} className="mb-2">
            <Checkbox checked={props.checked} onChange={onChange} />
        </LabelInline>
    )
}
async function fetchProductsByRC(rcId: number): Promise<Product[]> {
    const cached = productsCache.get(rcId)
    if (cached) {
        return cached
    }

    const company_id = storagePage.logistical_declaration.company_id
    const queries = parse(
        {
            reception_ids: [rcId]
        },
        `/v5.6/apis/companies/${company_id}/receptions/products`
    )

    const { data, error } = await get<Product[]>(queries)
    if (!error) {
        productsCache.set(rcId, data.result)
        return data.result
    }
    return []
}
